"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var REVIEW_DECK_LOAD_TIMEOUT_MS = 22000;
var ReviewDecksWrapper = function ReviewDecksWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "selectedDeck", _descriptor, _this);
      _initializerDefineProperty(_this, "showDeckSettings", _descriptor2, _this);
      _initializerDefineProperty(_this, "edit", _descriptor3, _this);
      _initializerDefineProperty(_this, "reviewDeckLoadFailed", _descriptor4, _this);
      _initializerDefineProperty(_this, "reviewDeckLoadFailureReason", _descriptor5, _this);
      _initializerDefineProperty(_this, "reviewDeckLoadErrorMessage", _descriptor6, _this);
      _this.onToggleEdit = function () {
        _this.edit = !_this.edit;
      };
      _this.afterCreateDeck = function () {
        _this.showDeckSettings = false;
      };
      _this.loadReviewDecks = function () {
        _this.reviewDeckLoadFailed = false;
        _this.reviewDeckLoadFailureReason = null;
        _this.reviewDeckLoadErrorMessage = null;
        _this.clearReviewDeckLoadTimeout();
        if (_state.AppUI.layout.isNative) {
          _state.AppUI.loadReviewDecks(null, {
            onRequestError: _this.onReviewDeckLoadError
          });
          _this.reviewDeckLoadTimeout = setTimeout(_this.onReviewDeckLoadTimeout, REVIEW_DECK_LOAD_TIMEOUT_MS);
        } else {
          _state.AppUI.loadReviewDecks();
        }
      };
      _this.clearReviewDeckLoadTimeout = function () {
        if (_this.reviewDeckLoadTimeout) {
          clearTimeout(_this.reviewDeckLoadTimeout);
          _this.reviewDeckLoadTimeout = null;
        }
      };
      _this.onReviewDeckLoadTimeout = function () {
        if (_state.AppUI.reviewDeckStore.indexData.length === 0) {
          _this.reviewDeckLoadFailed = true;
          _this.reviewDeckLoadFailureReason = 'timeout_waiting_for_review_decks';
        }
      };
      _this.onReviewDeckLoadError = function (err) {
        var _err$toString;
        _this.reviewDeckLoadFailed = true;
        _this.reviewDeckLoadFailureReason = 'review_deck_request_error';
        _this.reviewDeckLoadErrorMessage = (err === null || err === void 0 ? void 0 : err.message) || (err === null || err === void 0 || (_err$toString = err.toString) === null || _err$toString === void 0 ? void 0 : _err$toString.call(err)) || 'unknown request error';
        _this.clearReviewDeckLoadTimeout();
      };
      _this.updateReviewDeckLoadStatus = function () {
        if (!_state.AppUI.layout.isNative) {
          return;
        }
        var store = _state.AppUI.reviewDeckStore;
        if (store.indexData.length > 0) {
          _this.reviewDeckLoadFailed = false;
          _this.reviewDeckLoadFailureReason = null;
          _this.reviewDeckLoadErrorMessage = null;
          _this.clearReviewDeckLoadTimeout();
        } else if (store.initialRequestReceived && !store.hasOutstandingRequests) {
          _this.reviewDeckLoadFailed = false;
          _this.reviewDeckLoadFailureReason = null;
          _this.reviewDeckLoadErrorMessage = null;
          _this.clearReviewDeckLoadTimeout();
        }
      };
      _this.onSelectDeck = function (selectedDeck) {
        _this.selectedDeck = selectedDeck;
      };
      _this.onSetShowDeckSettings = function (showDeckSettings) {
        _this.showDeckSettings = showDeckSettings;
      };
      _this.closeOptions = function () {
        _this.selectedDeck = null;
        _this.showDeckSettings = false;
        _this.edit = false;
      };
      _this.closeOptionsAndUpdate = function () {
        _this.closeOptions();
        _this.loadReviewDecks();
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (_state.AppUI.reloadReviewDecks || _state.AppUI.reviewDeckStore.indexData.length === 0) {
          this.loadReviewDecks();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.mobileTabChangeTimeStamp !== this.props.mobileTabChangeTimeStamp && _state.AppUI.reloadReviewDecks) {
          this.loadReviewDecks();
        }
        this.updateReviewDeckLoadStatus();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearReviewDeckLoadTimeout();
      }
    }, {
      key: "showSpinner",
      get: function get() {
        var store = _state.AppUI.reviewDeckStore;
        return store.indexData.length === 0 && !this.showLoadError && (!store.initialRequestReceived || store.hasOutstandingRequests);
      }
    }, {
      key: "showLoadError",
      get: function get() {
        return _state.AppUI.layout.isNative && _state.AppUI.reviewDeckStore.indexData.length === 0 && this.reviewDeckLoadFailed;
      }
    }, {
      key: "supportMessage",
      get: function get() {
        var _AppUI$user;
        var store = _state.AppUI.reviewDeckStore;
        return ['Review decks failed to load', "Reason: ".concat(this.reviewDeckLoadFailureReason || 'unknown'), "User ID: ".concat(((_AppUI$user = _state.AppUI.user) === null || _AppUI$user === void 0 ? void 0 : _AppUI$user.id) || 'unknown'), "Target language: ".concat(_state.AppUI.targetLanguageId || 'unknown'), "Device language: ".concat(_state.AppUI.layout.deviceLanguageId || 'unknown'), "Platform: ".concat(_state.AppUI.layout.deviceOs || 'unknown'), "OS version: ".concat(_state.AppUI.layout.osVersion || _state.AppUI.api.osVersion || 'unknown'), "App version: ".concat(_state.AppUI.api.mobileVersionNumber || 'unknown'), "Error: ".concat(this.reviewDeckLoadErrorMessage || 'none'), "Request completed: ".concat(store.initialRequestReceived ? 'yes' : 'no'), "Outstanding requests: ".concat(store.requestCounter), "Loaded review decks: ".concat(store.indexData.length)].join('\n');
      }
    }, {
      key: "deckWidth",
      get: function get() {
        return _state.AppUI.layout.isMobile || _state.AppUI.layout.minimumHeight ? 170 : 190;
      }
    }, {
      key: "showDeckOptions",
      get: function get() {
        return !this.showDeckSettings && (0, _utils.isPresent)(this.selectedDeck);
      }
    }, {
      key: "filteredReviewDecks",
      get: function get() {
        if (this.props.archive) {
          return _state.VocabUI.archivedReviewDecks;
        }
        return _state.VocabUI.filteredReviewDecks;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showSpinner: this.showSpinner,
          selectedDeck: this.selectedDeck,
          showDeckSettings: this.showDeckSettings,
          showDeckOptions: this.showDeckOptions,
          showLoadError: this.showLoadError,
          supportMessage: this.supportMessage,
          onRetryLoadReviewDecks: this.loadReviewDecks,
          onSelectDeck: this.onSelectDeck,
          onSetShowDeckSettings: this.onSetShowDeckSettings,
          deckWidth: this.deckWidth,
          closeOptions: this.closeOptions,
          closeOptionsAndUpdate: this.closeOptionsAndUpdate,
          onToggleEdit: this.onToggleEdit,
          edit: this.edit,
          filteredReviewDecks: this.filteredReviewDecks,
          refreshSelectedDeck: this.refreshSelectedDeck
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "selectedDeck", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showDeckSettings", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "edit", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "reviewDeckLoadFailed", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "reviewDeckLoadFailureReason", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "reviewDeckLoadErrorMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return null;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showLoadError", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showLoadError"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "supportMessage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "supportMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "deckWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "deckWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDeckOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showDeckOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filteredReviewDecks", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredReviewDecks"), _class2.prototype), _class2)) || _class;
};
ReviewDecksWrapper.displayName = 'ReviewDecksWrapper';
var _default = exports["default"] = ReviewDecksWrapper;